import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export function getReferenceDataService(rateId) {
  return axios
    .get(`${BASE_URL}/reference`, { params: { rate: rateId } })
    .then(({ data }) => data);
}

export function saveSelectedChaptersService(chapters) {
  return axios
    .post(`${BASE_URL}/userChapterList`, { chapters })
    .then(({ data }) => data);
}

export function buildChapterStudyPlanService(start_date, exam_date) {
  return axios
    .post(`${BASE_URL}/buildChapterStudyPlan`, { start_date, exam_date })
    .then(({ data }) => data);
}

export function loadChapterStudyPlanService() {
  return axios.get(`${BASE_URL}/loadChapterStudyPlan`).then(({ data }) => data);
}
